/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActionsPopover/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import ScheduleAppointment from './ScheduleAppointment/index'
import ViewSchedule from './ViewSchedule/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ActionsPopover({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/ActionsPopover"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="ActionsPopover.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1m6xP7': dtColorsWhite,'--pl-2-Z1m6xP7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1m6xP7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-4-Z1m6xP7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-5-Z1m6xP7': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-6-Z1m6xP7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-Z1m6xP7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-8-Z1m6xP7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-9-Z1m6xP7': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-10-Z1m6xP7': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<ViewSchedule
  viewPath={`${viewPath}/ViewSchedule`}
/>
<ScheduleAppointment
  viewPath={`${viewPath}/ScheduleAppointment`}
/>
</div>
{children}
</React.Fragment>)
}